import api from './api';
import { News, NewsFormData, ApiResponse } from '../../types/news.types';

export const newsService = {
  getAll: async (): Promise<ApiResponse<News[]>> => {
    const response = await api.get<ApiResponse<News[]>>('/api/news');
    return response.data;
  },

  getById: async (id: number): Promise<ApiResponse<News>> => {
    const response = await api.get<ApiResponse<News>>(`/api/news/${id}`);
    return response.data;
  },

  create: async (data: NewsFormData): Promise<ApiResponse<News>> => {
    const response = await api.post<ApiResponse<News>>('/api/news', data);
    return response.data;
  },

  update: async (id: number, data: NewsFormData): Promise<ApiResponse<News>> => {
    const response = await api.put<ApiResponse<News>>(`/api/news/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<ApiResponse<void>> => {
    const response = await api.delete<ApiResponse<void>>(`/api/news/${id}`);
    return response.data;
  },

  uploadPdf: async (file: File): Promise<ApiResponse<{ url: string; filename: string }>> => {
    const fd = new FormData();
    fd.append('document', file);
    const response = await api.post<ApiResponse<{ url: string; filename: string }>>('/api/news/upload-pdf', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },
};